import { EventEmitter } from 'events';
import includes from 'lodash/includes';
import debounce from 'lodash/debounce';
import { isViewportInRange, viewportRanges } from './viewport-detection';

//
// A viewport utility for determining the current window size.
//
export default class Viewport extends EventEmitter {
    constructor() {
        super();
        this.size = null;
        this.handleResize();
        this.listen();
        this.width = window.innerWidth;
    }

    listen() {
        window.addEventListener(
            'resize',
            debounce(() => {
                // Don't trigger a change if the viewport width hasn't actually changed.
                // Scrolling on iOS will trigger a resize.
                if (this.width !== window.innerWidth) {
                    this.handleResize();
                }
            }, 100)
        );
    }

    handleResize() {
        this.width = window.innerWidth;

        Object.keys(viewportRanges).forEach(key => {
            var range = viewportRanges[key];

            if (isViewportInRange(range[0], range[1])) {
                this.size = key;
            }
        });

        this.emit('change');
    }

    inSize(range = []) {
        return includes(range, this.size);
    }
}
